
























import Vue from 'vue';
import {Component, Emit, Prop} from "vue-property-decorator";
import AsiToolbar from "./AsiToolbar.vue";
import AsiTextFieldSimple from "./AsiTextFieldSimple";
import AsiBtn from "./AsiBtn.vue";
import AsiListTableAdvancedFilters from "./AsiListTableAdvancedFilters.vue";
import AsiFadeTransition from "@/components/common/AsiFadeTransition.vue";

@Component({
	components: {AsiFadeTransition, AsiListTableAdvancedFilters, AsiBtn, AsiTextFieldSimple, AsiToolbar}
})
export default class AsiListTableLayout extends Vue {

	@Prop({type: Boolean, default: false})
	public hideToolbar!: boolean;

	@Prop({type: String, default: null})
	public filterText!: string | null;

	@Prop({type: Boolean, default: false})
	public hasFilter!: boolean;

	@Emit('clearSearch')
	public clearSearch(event: Event): Event {
	    return event;
	}

	@Emit('clearFilterText')
	public clearFilterText(event: Event): Event {
	    return event;
	}

	private get hasAdvancedFiltersContent(): boolean {
	    return !!this.$slots['advanced-filters'];
	}

}
